// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;
}

.spinner-content {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: auto;
  text-align: left;
  gap: 15px;
  max-width: 332px;
}

.spinner-wrapper {
  display: flex;
  align-items: center;
}

ion-spinner {
  font-size: 40px;
  color: #727272;
}

.spinner-content p {
  margin: 0;
  font-size: 14px;
  color: #727272;
  line-height: 1.4;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/custom-spinner/custom-spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,eAAA;EACA,cAAA;AAGF;;AADA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAIF","sourcesContent":[".spinner-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.20);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.spinner-content {\n  display: flex;\n  align-items: center;\n  background: #fff; \n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  width: auto;\n  text-align: left; \n  gap: 15px; \n  max-width: 332px;\n}\n.spinner-wrapper {\n  display: flex;\n  align-items: center;\n}\nion-spinner {\n  font-size: 40px; \n  color: #727272;\n}\n.spinner-content p {\n  margin: 0;\n  font-size: 14px;\n  color: #727272;\n  line-height: 1.4;\n  word-wrap: break-word;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
